import { render, staticRenderFns } from "./FileViewerModel.vue?vue&type=template&id=6973c9c6"
import script from "./FileViewerModel.vue?vue&type=script&lang=js"
export * from "./FileViewerModel.vue?vue&type=script&lang=js"
import style0 from "./FileViewerModel.vue?vue&type=style&index=0&id=6973c9c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports